// | ------------------------------------------------------------------------
// | Pages - Homepage
// | ------------------------------------------------------------------------

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  // Resets the quick contact form
  const resetButton = document.getElementById("resetButton");

  // Forms
  if (resetButton) {
    resetButton.addEventListener("click", () => {
      document.getElementById("quickEnquiryForm").reset();
    });
  }

  // Resets the quick contact form in the offcanvas
  const resetButtonOffcanvas = document.getElementById("resetButtonOffcanvas");

  // Forms
  if (resetButtonOffcanvas) {
    resetButtonOffcanvas.addEventListener("click", () => {
      document.getElementById("quickEnquiryFormOffcanvas").reset();
    });
  }
});
